module.exports = __webpack_public_path__ + "img/google-play-button.fe8a5916.svg";